// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SK-z","twoColumnImage":"TK-z"};